import { BasicTooltip } from '@nivo/tooltip'
import React from 'react'
import { markerColors, measureColor } from './index'
import styled from '@emotion/styled'
import { denormalizeNumber } from '@utils'

interface Props {
  v0: number
  v1?: number
  color: string
}

const rangeColor = ['#696969', '#989898', '#D3D3D3', 'white']

/**
 * Factory per il componente Custom tooltip per grafico Bullet
 * @param normalizedRange {any}
 * @param minimumRange {number=} parametro necessario per il calcolo corretto dei valori da visualizzare nel tooltip
 *
 * @summary
 * props del componente generato sono ereditate da @nivo </br>
 *  v0:number </br>
 *  v1?:number </br>
 *  color:string</br>
 * @component
 */
export const CustomTooltip: (
  normalizedRange: any,
  minimumRange?: number
) => React.FC<Props> =
  (normalizedRange, minimumRange) =>
  ({ v0, v1, color }) => {
    const Content = () => {
      const point = {
        min: denormalizeNumber(normalizedRange[0], minimumRange),
        max: denormalizeNumber(normalizedRange[1], minimumRange),
        v0: denormalizeNumber(v0, minimumRange),
        v1: v1 ? denormalizeNumber(v1, minimumRange) : null,
      }

      if (color === measureColor) {
        return (
          <>
            Current RPE : <strong>{point.v0}</strong>
          </>
        )
      }
      if (color === markerColors) {
        return (
          <>
            Average RPE : <strong>{point.v0}</strong>
          </>
        )
      }

      for (let i = 0; i <= rangeColor.length; i++) {
        if (color === rangeColor[i]) {
          if (i === 0) {
            return (
              <Container>
                <div>Minimum RPE - 25th percentile</div>
                <div>
                  from: <strong>{point.v0}</strong>
                </div>
                <div>
                  to: <strong>{point.v1}</strong>
                </div>
              </Container>
            )
          }
          if (i === 1) {
            return (
              <Container>
                <div>25th percentile - 50th percentile</div>
                <div>
                  from: <strong>{point.v0}</strong>
                </div>
                <div>
                  to: <strong>{point.v1}</strong>
                </div>
              </Container>
            )
          }
          if (i === 2) {
            return (
              <Container>
                <div>50th percentile - 75th percentile</div>
                <div>
                  from: <strong>{point.v0}</strong>
                </div>
                <div>
                  to: <strong>{point.v1}</strong>
                </div>
              </Container>
            )
          }
          return (
            <Container>
              <div>75th percentile - Maximum RPE</div>
              <div>
                from: <strong>{point.v0}</strong>
              </div>
              <div>
                to: <strong>{point.v1}</strong>
              </div>
            </Container>
          )
        }
      }
      if (color === 'transparent') {
        if (point.v0 === point.min) {
          return (
            <Container>
              <div>Global Minimum - Local minimum</div>
              <div>
                from: <strong>{point.v0}</strong>
              </div>
              <div>
                to: <strong>{point.v1}</strong>
              </div>
            </Container>
          )
        }
        if (point.v1 === point.max) {
          return (
            <Container>
              <div>Local Maximum - Global Maximum</div>
              <div>
                from: <strong>{point.v0}</strong>
              </div>
              <div>
                to: <strong>{point.v1}</strong>
              </div>
            </Container>
          )
        }
      }

      return null
    }

    return Content() ? (
      <BasicTooltip id={Content()} enableChip={true} color={color} />
    ) : (
      <></>
    )
  }

const Container = styled.div`
  display: grid;
`
